module.exports = __webpack_public_path__ + "static/media/academia-img1.44bc262c.svg";